import '@styles/views/introduce.less';
import AppAdvantage from '@components/app/appAdvantage';
import AppDisplayDesc from '@components/app/appDisplayDesc';
import AppFooter from '@components/app/appFooter';
import AppBannerNew from '@components/app/appBannerNew';
import AppBimWindows from '@components/app/appBimWindows';

const Introduce = () => {
  return (
    <div className={'introduce-page'}>
      <AppBannerNew />
      <AppBimWindows />
      <AppAdvantage showDesc style={{ marginTop: '30px' }} />
      <AppDisplayDesc />
      <AppFooter />
    </div>
  );
};

export default Introduce;
